import { API_URL } from "./apiConfig";

export const EvaluationForCandidate = async (newRequest) => {
  try {
    const response = await fetch(`${API_URL}Evaluations/EvaluationForCandidate`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(newRequest),
    });
    if (response.ok) return await response.json();
    return { status: response.status };
  } catch (error) {
    console.error("API call failed:", error);
    throw error;
  }
};
